<template>
  <b-row class="bar-graph no-gutters">
   
    <b-col class="graph-container flex-item" cols="12">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 545 209" style="enable-background:new 0 0 560 244;" xml:space="preserve">
      
        <g id="graph-background">
          <rect :x="xOffset" y="1" rx="5" ry="5" :width="graphWidth" :height="graphHeight" style="fill:#f2f2f2;stroke:none;"/>
        </g>
        
        
        <!--//**************************************y labels*******************************************-->
        <g id="ylabels">
        <!--Y Labels-->
        <text class="y-labels" v-for="(bar,index) in ylabelpos" v-bind:key="index" :class="{'hyplip-y-lbl':disease=='hyplip'}" :y="bar.y" :x="bar.x" text-anchor="middle" :transform="'rotate(-90,'+bar.x+','+bar.y+')'">{{bar.value}}</text>
        <!--BMI Values-->
        <g v-if="lblY[0]===bmi">
          <text class="y-labels" :y="ylabelBmi[0].y" :x="ylabelBmi[0].x" text-anchor="middle" :transform="'rotate(-90,'+ylabelBmi[0].x+','+ylabelBmi[0].y+')'">{{ylabelBmi[0].value}}</text>
          <g v-if="adjustSelection==0">
            <text class="y-labels" :y="ylabelBmi[1].y" :x="ylabelBmi[1].x" text-anchor="middle" :transform="'rotate(-90,'+ylabelBmi[1].x+','+ylabelBmi[1].y+')'">--</text>
          </g>
          <g v-if="adjustSelection==5">
            <text class="y-labels" :y="ylabelBmi[1].y" :x="ylabelBmi[1].x" text-anchor="middle" :transform="'rotate(-90,'+ylabelBmi[1].x+','+ylabelBmi[1].y+')'">{{ylabelBmi[1].value}}</text>
          </g>
          <g v-if="adjustSelection==10">
            <text class="y-labels" :y="ylabelBmi[2].y" :x="ylabelBmi[2].x" text-anchor="middle" :transform="'rotate(-90,'+ylabelBmi[2].x+','+ylabelBmi[2].y+')'">{{ylabelBmi[2].value}}</text>
          </g>
          <g v-if="adjustSelection==15">
            <text class="y-labels" :y="ylabelBmi[3].y" :x="ylabelBmi[3].x" text-anchor="middle" :transform="'rotate(-90,'+ylabelBmi[3].x+','+ylabelBmi[3].y+')'">{{ylabelBmi[3].value}}</text>
          </g>
          <g v-if="adjustSelection==20">
            <text class="y-labels" :y="ylabelBmi[4].y" :x="ylabelBmi[4].x" text-anchor="middle" :transform="'rotate(-90,'+ylabelBmi[4].x+','+ylabelBmi[4].y+')'">{{ylabelBmi[4].value}}</text>
          </g>
        </g>
        </g>
        
        <!--//**************************************END - y labels********************************************-->
        
        <!--//**************************************x labels********************************************-->
        <g id="xlabels">
        <g class="x-labels">
        <text text-anchor="middle" style="fill:#001965; font-family:verdana ,serif; font-size:12px;" v-for="(bar,index) in xlabelpos" v-bind:key="index" :y="bar.y" :x="bar.x">{{bar.value|labelX(lblEndX,disease)}}</text>
        </g>
        </g>
        <!--//**************************************END - x labels********************************************-->
        
        <!--//************************************** BARS ********************************************-->
        <g id="bars" v-if="displayBars">
          <g class="disease bars">
            <rect v-for="(bar,index) in currentBars" v-bind:key="'curr'+index" :y="bar.y" :x="bar.x" :width="bar.width" :height="bar.height" style="fill:#001965;stroke:none;"/>
            <g v-if="adjustSelection==5">
              <rect v-for="(bar,index) in adj5Bars" v-bind:key="'five'+index" :y="bar.y" :x="bar.x" :width="bar.width" :height="bar.height" style="fill:#3f9c35;stroke:none;"/>
              </g>
            <g v-if="adjustSelection==10">
              <rect v-for="(bar,index) in adj10Bars" v-bind:key="'ten'+index" :y="bar.y" :x="bar.x" :width="bar.width" :height="bar.height" style="fill:#3f9c35;stroke:none;"/>
              </g>
            <g v-if="adjustSelection==15">
              <rect v-for="(bar,index) in adj15Bars" v-bind:key="'fifteen'+index" :y="bar.y" :x="bar.x" :width="bar.width" :height="bar.height" style="fill:#3f9c35;stroke:none;"/>
              </g>
            <g v-if="adjustSelection==20">
              <rect v-for="(bar,index) in adj20Bars" v-bind:key="'twenty'+index" :y="bar.y" :x="bar.x" :width="bar.width" :height="bar.height" style="fill:#3f9c35;stroke:none;"/>
              </g>
          </g>
          
          <g>
            
            <g v-if="disease!='oa' && disease != 'yll' && disease!= 'pcos'">
              <text v-for="(txt,i) in currentText" dominant-baseline="top" v-bind:key="i" text-anchor="start" class="bar-text not-oa" :class="{'hyplip-text':disease=='hyplip','htn-text':disease=='hypten','yll-text':disease=='yll'||disease=='diab','white-text':white.current[i]}" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.current[i]|barText(disease)}}</text>
            
              <g v-if="adjustSelection==5">
               <text v-for="(txt,i) in adj5Text" dominant-baseline="top" v-bind:key="i" text-anchor="start" class="bar-text adjusted-text" :class="{'hyplip-text':disease=='hyplip','htn-text':disease=='hypten','yll-text':disease=='yll'||disease=='diab','white-text':white.adj5[i]}" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.adj5[i]|barText(disease)}}</text>
             </g>
              <g v-if="adjustSelection==10">
                <text v-for="(txt,i) in adj10Text" dominant-baseline="top" v-bind:key="i" text-anchor="start" class="bar-text adjusted-text" :class="{'hyplip-text':disease=='hyplip','htn-text':disease=='hypten','yll-text':disease=='yll'||disease=='diab','white-text':white.adj10[i]}" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.adj10[i]|barText(disease)}}</text>
              </g>
              <g v-if="adjustSelection==15">
                <text v-for="(txt,i) in adj15Text" dominant-baseline="top" v-bind:key="i" text-anchor="start" class="bar-text adjusted-text" :class="{'hyplip-text':disease=='hyplip','htn-text':disease=='hypten','yll-text':disease=='yll'||disease=='diab','white-text':white.adj15[i]}" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.adj15[i]|barText(disease)}}</text>
              </g>
              <g v-if="adjustSelection==20">
                <text v-for="(txt,i) in adj20Text" dominant-baseline="top" v-bind:key="i" text-anchor="start" class="bar-text adjusted-text" :class="{'hyplip-text':disease=='hyplip','htn-text':disease=='hypten','yll-text':disease=='yll'||disease=='diab','white-text':white.adj20[i]}" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.adj20[i]|barText(disease)}}</text>
              </g>
            </g>
            <!-----oa-->
            <g v-if="disease=='oa'">
              <g v-for="(txt,c) in currentText"  v-bind:key="c" >
              <text dominant-baseline="top" text-anchor="start" class="bar-text" :class="{'hyplip-text':disease=='hyplip','htn-text':disease=='hypten','yll-text':disease=='yll'||disease=='diab'}" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.current[c]|barText(disease)}}</text>
              <text dominant-baseline="top" text-anchor="start" class="bar-text" :y="txt.y" :x="txt.x+45" dy="0.3em" alignment-baseline="top">{{$t('graph.painReduction')}}</text>
             </g>
              <g v-if="adjustSelection==5">
                <g  v-for="(txt,a) in adj5Text" v-bind:key="a">
                 <text dominant-baseline="top" text-anchor="start" class="bar-text adjusted-text" :class="{'hyplip-text':disease=='hyplip','htn-text':disease=='hypten','yll-text':disease=='yll'||disease=='diab'}" :y="txt.y" :x="txt.x+17" dy="0.3em" alignment-baseline="top">{{barValues.adj5[a]|barText(disease)}}</text>
                 <text dominant-baseline="top" text-anchor="start" class="bar-text adjusted-text" :y="txt.y" :x="txt.x+63" dy="0.3em" alignment-baseline="top">{{$t('graph.painReduction')}}</text>
                </g>
              </g>
              <g v-if="adjustSelection==10">
                <g  v-for="(txt,a) in adj10Text" v-bind:key="a">
                  <text dominant-baseline="top" text-anchor="end" class="bar-text adjusted-text osteo white-text" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.adj10[a]|barText(disease)}}</text>
                 <text dominant-baseline="top" text-anchor="start" class="bar-text adjusted-text" :y="txt.y" :x="txt.x+15" dy="0.3em" alignment-baseline="top">{{$t('graph.painReduction')}}</text>
                </g>
              </g>
              <g v-if="adjustSelection==15">
                <g  v-for="(txt,a) in adj15Text" v-bind:key="a">
                  <text dominant-baseline="top"  text-anchor="end" class="bar-text adjusted-text osteo white-text" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.adj15[a]|barText(disease)}}</text>
                   <text dominant-baseline="top" text-anchor="start" class="bar-text adjusted-text" :y="txt.y" :x="txt.x+15" dy="0.3em" alignment-baseline="top">{{$t('graph.painReduction')}}</text>
                </g>
              </g>
              <g v-if="adjustSelection==20">
                <g  v-for="(txt,a) in adj20Text" v-bind:key="a">
                  <text dominant-baseline="top" text-anchor="end" class="bar-text adjusted-text osteo white-text" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.adj20[a]|barText(disease)}}</text>
                  <text dominant-baseline="top" text-anchor="start" class="bar-text adjusted-text" :y="txt.y" :x="txt.x+15" dy="0.3em" alignment-baseline="top">{{$t('graph.painReduction')}}</text>
                </g>
              </g>
            </g>
            <!------->
            
            <!-----yll-->
            <g v-if="disease=='yll'">
              <g v-for="(txt,c) in currentText"  v-bind:key="c" >
              <text v-for="(txt,i) in currentText" dominant-baseline="top" v-bind:key="i" text-anchor="start" class="bar-text not-oa" :class="{'yll-text':disease=='yll','white-text':white.current[i]}" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.current[i]|barText(disease)}} {{$t('graph.years')}}</text>
             </g>
             
              <g v-if="$i18n.locale=='sp'" >
                <text dominant-baseline="top" text-anchor="start" style="fill:#001965; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.current[0]}" 
                 :y="ci.y.current" :x="ci.x.current" dy="0.3em" alignment-baseline="top">Intervalo de</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#001965; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.current[0]}"
                :y="ci.y.current+13" :x="ci.x.current" dy="0.3em">confianza del 95%:</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#001965; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.current[0]}"
                :y="ci.y.current+26" :x="ci.x.current" dy="0.3em">({{confInt.current[0] |confIntvl}}-{{confInt.current[1] |confIntvl}})</text>
              </g>
              <g v-if="$i18n.locale=='en'" >
                <text dominant-baseline="top" text-anchor="start" style="fill:#001965; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':cie.white.current[0]}" 
                 :y="cie.y.current" :x="cie.x.current" dy="0.3em" alignment-baseline="top">95% Confidence</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#001965; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':cie.white.current[0]}"
                :y="cie.y.current+13" :x="cie.x.current" dy="0.3em">Interval: ({{confInt.current[0] |confIntvl}}-{{confInt.current[1] |confIntvl}})</text>
              </g>
              
              <g v-if="adjustSelection==5">
                <g  v-for="(txt,a) in adj5Text" v-bind:key="a">
                  <text v-for="(txt,i) in adj5Text" dominant-baseline="top" v-bind:key="i" text-anchor="start" class="bar-text adjusted-text" :class="{'yll-text':disease=='yll','white-text':white.adj5[i]}" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.adj5[i]|barText(disease)}} {{$t('graph.years')}}</text>
                </g>
                
                <g v-if="$i18n.locale=='sp'" >
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.adj5[0]}" 
                 :y="ci.y.adj5" :x="ci.x.adj5" dy="0.3em" alignment-baseline="top">Intervalo de</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.adj5[0]}"
                :y="ci.y.adj5+13" :x="ci.x.adj5" dy="0.3em">confianza del 95%:</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.adj5[0]}"
                :y="ci.y.adj5+26" :x="ci.x.adj5" dy="0.3em">({{confInt.adj5[0] |confIntvl}}-{{confInt.adj5[1] |confIntvl}})</text>
              </g>
              
              <g v-if="$i18n.locale=='en'" >
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':cie.white.adj5[0]}" 
                 :y="cie.y.adj5" :x="cie.x.adj5" dy="0.3em" alignment-baseline="top">95% Confidence</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':cie.white.adj5[0]}"
                :y="cie.y.adj5+13" :x="cie.x.adj5" dy="0.3em">Interval: ({{confInt.adj5[0] |confIntvl}}-{{confInt.adj5[1] |confIntvl}})</text>
              </g>
              
              </g>
              <g v-if="adjustSelection==10">
                <g  v-for="(txt,a) in adj10Text" v-bind:key="a">
                   <text v-for="(txt,i) in adj10Text" dominant-baseline="top" v-bind:key="i" text-anchor="start" class="bar-text adjusted-text" :class="{'yll-text':disease=='yll','white-text':white.adj10[i]}" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.adj10[i]|barText(disease)}} {{$t('graph.years')}}</text>
                </g>
                
                <g v-if="$i18n.locale=='sp'" >
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.adj10[0]}" 
                 :y="ci.y.adj10" :x="ci.x.adj10" dy="0.3em" alignment-baseline="top">Intervalo de</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.adj10[0]}"
                :y="ci.y.adj10+13" :x="ci.x.adj10" dy="0.3em">confianza del 95%:</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.adj10[0]}"
                :y="ci.y.adj10+26" :x="ci.x.adj10" dy="0.3em">({{confInt.adj10[0] |confIntvl}}-{{confInt.adj10[1] |confIntvl}})</text>
              </g>
              
              <g v-if="$i18n.locale=='en'" >
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':cie.white.adj10[0]}" 
                 :y="cie.y.adj10" :x="cie.x.adj10" dy="0.3em" alignment-baseline="top">95% Confidence</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':cie.white.adj10[0]}"
                :y="cie.y.adj10+13" :x="cie.x.adj10" dy="0.3em">Interval: ({{confInt.adj10[0] |confIntvl}}-{{confInt.adj10[1] |confIntvl}})</text>
              </g>
              
              </g>
              <g v-if="adjustSelection==15">
                <g  v-for="(txt,a) in adj15Text" v-bind:key="a">
                 <text v-for="(txt,i) in adj15Text" dominant-baseline="top" v-bind:key="i" text-anchor="start" class="bar-text adjusted-text" :class="{'yll-text':disease=='yll','white-text':white.adj15[i]}" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.adj15[i]|barText(disease)}} {{$t('graph.years')}}</text>
                </g>
                
                <g v-if="$i18n.locale=='sp'" >
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.adj15[0]}" 
                 :y="ci.y.adj15" :x="ci.x.adj15" dy="0.3em" alignment-baseline="top">Intervalo de</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.adj15[0]}"
                :y="ci.y.adj15+13" :x="ci.x.adj15" dy="0.3em">confianza del 95%:</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.adj15[0]}"
                :y="ci.y.adj15+26" :x="ci.x.adj15" dy="0.3em">({{confInt.adj15[0] |confIntvl}}-{{confInt.adj15[1] |confIntvl}})</text>
              </g>
              
              <g v-if="$i18n.locale=='en'" >
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':cie.white.adj15[0]}" 
                 :y="cie.y.adj15" :x="cie.x.adj15" dy="0.3em" alignment-baseline="top">95% Confidence</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':cie.white.adj15[0]}"
                :y="cie.y.adj15+13" :x="cie.x.adj15" dy="0.3em">Interval: ({{confInt.adj15[0] |confIntvl}}-{{confInt.adj15[1] |confIntvl}})</text>
              </g>
              
              </g>
              <g v-if="adjustSelection==20">
                <g  v-for="(txt,a) in adj20Text" v-bind:key="a">
                  <text v-for="(txt,i) in adj20Text" dominant-baseline="top" v-bind:key="i" text-anchor="start" class="bar-text adjusted-text" :class="{'yll-text':disease=='yll','white-text':white.adj20[i]}" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.adj20[i]|barText(disease)}} {{$t('graph.years')}}</text>
                </g>
                
                <g v-if="$i18n.locale=='sp'" >
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.adj20[0]}" 
                 :y="ci.y.adj20" :x="ci.x.adj20" dy="0.3em" alignment-baseline="top">Intervalo de</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.adj20[0]}"
                :y="ci.y.adj20+13" :x="ci.x.adj20" dy="0.3em">confianza del 95%:</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':ci.white.adj20[0]}"
                :y="ci.y.adj20+26" :x="ci.x.adj20" dy="0.3em">({{confInt.adj20[0] |confIntvl}}-{{confInt.adj20[1] |confIntvl}})</text>
              </g>
              
              <g v-if="$i18n.locale=='en'" >
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':cie.white.adj20[0]}" 
                 :y="cie.y.adj20" :x="cie.x.adj20" dy="0.3em" alignment-baseline="top">95% Confidence</text>
                <text dominant-baseline="top" text-anchor="start" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:11px;" :class="{'yll-text':disease=='yll','white-text':cie.white.adj20[0]}"
                :y="cie.y.adj20+13" :x="cie.x.adj20" dy="0.3em">Interval: ({{confInt.adj20[0] |confIntvl}}-{{confInt.adj20[1] |confIntvl}})</text>
              </g>
              
              </g>
            </g>
            <!------->
            
                 <!-----pcos-->
            <g v-if="disease=='pcos'">
              <g v-for="(txt,c) in currentText"  v-bind:key="c" >
                  <text v-for="(txt,i) in currentText" dominant-baseline="top" v-bind:key="i" text-anchor="start" class="bar-text not-oa" :class="{'white-text':white.current[i]}" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.current[i]|barText(disease)}} {{$t('graph.pcosUnit')}}</text>
             </g>
              <g v-if="adjustSelection==5">
                <g  v-for="(txt,a) in adj5Text" v-bind:key="a">
                  <text v-for="(txt,i) in adj5Text" dominant-baseline="top" v-bind:key="i" text-anchor="start" class="bar-text adjusted-text" :class="{'white-text':white.adj5[i]}" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.adj5[i]|barText(disease)}} {{$t('graph.pcosUnit')}}</text>
                </g>
              </g>
              <g v-if="adjustSelection==10">
                <g  v-for="(txt,a) in adj10Text" v-bind:key="a">
                   <text v-for="(txt,i) in adj10Text" dominant-baseline="top" v-bind:key="i" text-anchor="start" class="bar-text adjusted-text" :class="{'white-text':white.adj10[i]}" :y="txt.y" :x="txt.x" dy="0.3em" alignment-baseline="top">{{barValues.adj10[i]|barText(disease)}} {{$t('graph.pcosUnit')}}</text>
                </g>
              </g>
            
             
            </g>
            <!------->
          </g>
          
        </g>
        
    
        
        <!--****************************************** CI ********************************************-->
        
        <!--<g v-if="adjustSelection==20">-->
        <!--  <text text-anchor="middle" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y" :x="confIntPos.x">-->
        <!--    {{$t('graph.confidenceInterval')}}</text>-->
        <!--    <text text-anchor="middle" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y+20" :x="confIntPos.x">-->
        <!--    ({{confInt.adj20[0]}}-{{confInt.adj20[1]}})</text>-->
        <!--</g>-->
        <!--<g v-if="adjustSelection==15">-->
        <!--  <text text-anchor="middle" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y" :x="confIntPos.x">-->
        <!--    {{$t('graph.confidenceInterval')}}</text>-->
        <!--    <text text-anchor="middle" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y+20" :x="confIntPos.x">-->
        <!--    ({{confInt.adj15[0]}}-{{confInt.adj15[1]}})</text>-->
        <!--</g>-->
        <!--<g v-if="adjustSelection==10">-->
        <!--  <text text-anchor="middle" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y" :x="confIntPos.x">-->
        <!--    {{$t('graph.confidenceInterval')}}</text>-->
        <!--    <text text-anchor="middle" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y+20" :x="confIntPos.x">-->
        <!--    ({{confInt.adj10[0]}}-{{confInt.adj10[1]}})</text>-->
        <!--</g>-->
        <!--<g v-if="adjustSelection==5">-->
        <!--  <text text-anchor="middle" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y" :x="confIntPos.x">-->
        <!--    {{$t('graph.confidenceInterval')}}</text>-->
        <!--    <text text-anchor="middle" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y+20" :x="confIntPos.x">-->
        <!--    ({{confInt.adj5[0]}}-{{confInt.adj5[1]}})</text>-->
        <!--</g>-->
        <!--<g v-if="!(adjustSelection==5 || adjustSelection==10 || adjustSelection==15 || adjustSelection==20)">-->
        <!--  <text text-anchor="middle" style="fill:#001965; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y" :x="confIntPos.x">-->
        <!--    {{$t('graph.confidenceInterval')}}</text>-->
        <!--    <text text-anchor="middle" style="fill:#001965; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y+20" :x="confIntPos.x">-->
        <!--     ({{confInt.current[0]}}-{{confInt.current[1]}})</text>-->
        <!--</g>-->
        
        
        //**************************************gridbox********************************************
        
        <g id="graphbox">
          <rect :x="xOffset" y="1" rx="5" ry="5" :width="graphWidth" :height="graphHeight" style="fill:none;stroke:#001965;stroke-width:1;stroke:#001965"/>
        </g>
        //**************************************END - gridbox********************************************
        
      </svg>
    </b-col>
  </b-row>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: "barGraph",
    mounted: function() {
      // set graph width
      switch (this.disease) {
        case "hyplip":
        case "hypten":
          this.graphWidth=511;
          this.xOffset=25;
          break;
        case "diab":
          this.graphWidth=528;
          this.xOffset=1;
          break;
        default:
          this.graphWidth=473;
          this.xOffset=40;
      }
      
      // create labels
      this.createLabelsY();
      this.createLabelsX();
      this.drawBars();
      
      console.log('in LC - conf int: '+JSON.stringify(this.ci));
    },
    components: {},
    computed: {
      ...mapGetters('userData', ['userData']),
    },
    data() {
      return {
        ci: {
          x: {
            current: 375,
            adj5: 375,
            adj10: 375,
            adj15: 375,
            adj20: 375, 
          },
          y: {
            current: 40,
            adj5: 125,
            adj10: 125,
            adj15: 125,
            adj20: 125,
          },
          white: {
            current:[false],
            adj5:[false],
            adj10: [false],
            adj15:[false],
            adj20: [false],
          },
        },
        cie: {
          x: {
            current: 375,
            adj5: 375,
            adj10: 375,
            adj15: 375,
            adj20: 375, 
          },
          y: {
            current: 48,
            adj5: 133,
            adj10: 133,
            adj15: 133,
            adj20: 133,
          },
          white: {
            current:[false],
            adj5:[false],
            adj10: [false],
            adj15:[false],
            adj20: [false],
          },
        },
        xOffset: 40,
        bmi: this.$t('common.bmi'),
        graphWidth: 473,
        graphHeight: 186,
        currentBars: [],
        adj5Bars: [],
        adj10Bars: [],
        adj15Bars: [],
        adj20Bars: [],
        currentText: [],
        adj5Text: [],
        adj10Text: [],
        adj15Text: [],
        adj20Text: [],
        textOffset: {
          curr: [0],
          adj5: [0],
          adj10: [0],
          adj15: [0],
          adj20: [0],
        },
        xlabelpos: [],
        ylabelpos: [],
        ylabelBmi: [
                {x: 26, y: 1, value:''},
                {x: 26, y: 1, value:''},
                {x: 26, y: 1, value:''},
                {x: 26, y: 1, value:''},
                {x: 26, y: 1, value:''},
                ],
        lblYMarginX: 28,
        
        labelY: {
          count: 0,
          height: 0,
        },
        labelX: {
          count: 0,
          width: 0,
        },
        white: {
          current:[false],
          adj5:[false],
          adj10: [false],
          adj15:[false],
          adj20: [false],
        },
        confIntPos: {y:100 , x:100},
      };
    },
    props: {
       confInt: {
        type: Object,
      },
      disease: {
        type: String,
        required: true
      },
      barValues: {
        type: Object,
      },
      adjustSelection: {
        type: Number,
      },
      displayBars: {
        type: Boolean,
      },
      displayGraph: {
        type: Boolean,
      },
      
      isSummary: {
        type: Boolean,
        default: false
      },
      lblY: {
        type: Array,
        default: () => []
      },
      lblStartX: {
        type: Number,
        default: 0
      },
      lblEndX: {
        type: Number,
        default: 100
      },
      lblSkipX: {
        type: Number,
        default: 25
      },
      
      lblEndY: {
        type: Number,
        default: 2.5
      },
      lblSkipY: {
        type: Number,
        default: 0.5
      },
      
    },
    
    filters: {
      labelX: function(value,last,disease) {
        if (disease=='diab') {
          return value+'.0';
        } else if (value==last && (disease=='hyplip'||disease=='hypten'||disease=='yll')) {
          return value+'+';
        } else if(disease=='hypten' && value==50) {
          return '≤'+value;
        } else {
          return value;
        }
      },
      barText: function(value,disease) {
        
        if(disease=='nafld') {
          return value+'% Improvement';
        } else if(disease=='oa') {
          return value+'%';
        } else if(disease=='diab') {
          if(value%1==0) {
            return value+'.'+'0'+'%';
          } else {
            return value+'%';
          }
        } else if(disease=='yll') {
          if (value==1) {
            return value+'.0 ' ;
          } else if (value<0){
            return '<0.0 ';
          } else if (value%1==0) {
            return value+'.0 ';
          } else {
            return value +' ' ;
          }
        } else if(disease=='pcos') {
          return value+'% ';
        } else if(disease=='hyplip') {
          if (value<0) {
            return '<0';
          } else {
            return value;
          }
        } else {
          return value;
        }
      },
      confIntvl: function(value) {
        if(value%1==0 && value!==0) {
          return value+'.'+'0';
        } else {
          return value;
        }
      },
    },
    methods: {
      createLabelsY: function() {
        this.ylabelpos=[];
        var bmi = Math.round(this.userData.bmi);
        var bmi5 = Math.round(this.userData.calc.bmi.adj5);
        var bmi10 = Math.round(this.userData.calc.bmi.adj10);
        var bmi15 = Math.round(this.userData.calc.bmi.adj15);
        var bmi20 = Math.round(this.userData.calc.bmi.adj20);
        
        var labelCount = this.lblY.length;
        if (labelCount<1) {
          this.ylabelpos.push({
              x:this.xOffset/2,
              y:0,
              value:''
              });
        } else {
          switch (this.disease) {
            case "hyplip":
              this.ylabelpos = [
                {x: 12, y: 1+(this.graphHeight/3)-1, value:this.lblY[0]},
                {x: 12, y: 1+this.graphHeight-((this.graphHeight-138)/6)-30, value:this.lblY[1]},
              ];
              break;
            case "hypten":
              this.ylabelpos = [
                {x: 12, y: 1+( (this.graphHeight-129.6)/3)+32.4, value:this.lblY[0]},
                {x: 12, y: 1+( (this.graphHeight-129.6)*2/3)+64.8+32.4, value:this.lblY[1]}
                ];
              break;
            case "diab":
              this.graphWidth=528;
              this.xOffset=1;
              break;
            case "nafld":
              this.ylabelpos = [
                {x: 26, y: 1+((this.graphHeight-126)/3)+31.5, value:this.lblY[0]},
                {x: 26, y: 1+(2*((this.graphHeight-126)/3))+94.5, value:this.lblY[1]}
              ];
              break;
            default:
              this.ylabelpos = [
                {x: 12, y: 1+((this.graphHeight-126)/3)+31.5, value:this.lblY[0]},
                {x: 12, y: 1+(2*((this.graphHeight-126)/3))+94.5, value:this.lblY[1]}
              ];
              this.ylabelBmi = [
                {x: 31, y: 1+((this.graphHeight-126)/3)+31.5, value:bmi},
                {x: 31, y: 1+(2*((this.graphHeight-126)/3))+94.5, value:bmi5},
                {x: 31, y: 1+(2*((this.graphHeight-126)/3))+94.5, value:bmi10},
                {x: 31, y: 1+(2*((this.graphHeight-126)/3))+94.5, value:bmi15},
                {x: 31, y: 1+(2*((this.graphHeight-126)/3))+94.5, value:bmi20},
                ];
          }
        }
      },
      createLabelsX: function() {
        this.xlabelpos=[];
        var labelCount = (this.lblEndX - this.lblStartX) / this.lblSkipX;
        var labelWidth= (this.graphWidth)/labelCount;
        if (this.disease=='hyplip'||this.disease=='hypten') {labelWidth=labelWidth-0.5;}
        this.labelX={count:labelCount, width:labelWidth};
        var x=this.xOffset;
        // Loop through the Labels 
        var startoffset= this.disease=='diab'?10:2;
        var endoffset= (this.disease=='hyplip'||this.disease=='hypten')?0:((this.disease=='oa'|| this.disease=='yll')?5:10);
        for(var i=0; i<=labelCount; i++) {
          var value = this.lblStartX + (i * this.lblSkipX);
          this.xlabelpos.push({
            x:i==0?(x+startoffset):(i==labelCount?(x-endoffset):x),
            y:this.graphHeight+1+19,
            value:value
          });
          x = x+labelWidth;     
        }
      },
      
      getBarWidth: function(value) {
        var bars= ((this.graphWidth/(this.lblEndX-this.lblStartX)) * (value - this.lblStartX));
        return (bars>(this.graphWidth-2))?this.graphWidth:(bars<0?0:bars);
      },
      
      drawBars: function() { 
        var yPos, barWidth, barHeight;
        var barCount=this.barValues.current.length;
        
        switch (this.disease) {
          case "oa":
            this.textOffset.curr= [9];
            this.textOffset.adj5= [-8];
            this.textOffset.adj10= [-8];
            this.textOffset.adj15= [-8];
            this.textOffset.adj20= [-8];
            break;
          case "yll":
            this.textOffset.curr= [this.barValues.current<6?11:(this.barValues.current>=10?-165:-145)];
            this.textOffset.adj5= [this.barValues.adj5<6?11:(this.barValues.adj5>=10?-165:-145)];
            this.textOffset.adj10= [this.barValues.adj10<6?11:(this.barValues.adj10>=10?-165:-145)];
            this.textOffset.adj15= [this.barValues.adj15<6?11:(this.barValues.adj15>=10?-165:-145)];
            this.textOffset.adj20= [this.barValues.adj20<6?11:(this.barValues.adj20>=10?-165:-145)];
            this.white = {
              current:[this.barValues.current<6?false:true],
              adj5:[this.barValues.adj5<6?false:true],
              adj10:[this.barValues.adj10<6?false:true],
              adj15:[this.barValues.adj15<6?false:true],
              adj20: [this.barValues.adj20<6?false:true],
            };
            this.ci.white = {
              current:[this.barValues.current<3.8?false:true],
              adj5:[this.barValues.adj5<3.8?false:true],
              adj10:[this.barValues.adj10<3.8?false:true],
              adj15:[this.barValues.adj15<3.8?false:true],
              adj20: [this.barValues.adj20<3.8?false:true],
            };
            this.ci.x = {
              current:[this.barValues.current<3.8? this.ci.x.current : 50],
              adj5:[this.barValues.adj5<3.8? this.ci.x.adj5 : 50],
              adj10:[this.barValues.adj10<3.8? this.ci.x.adj10 : 50],
              adj15:[this.barValues.adj15<3.8? this.ci.x.adj15 : 50],
              adj20: [this.barValues.adj20<3.8? this.ci.x.adj20 : 50],
            };
            this.cie.x = {
              current:[this.barValues.current<3.8? this.ci.x.current : 50],
              adj5:[this.barValues.adj5<3.8? this.ci.x.adj5 : 50],
              adj10:[this.barValues.adj10<3.8? this.ci.x.adj10 : 50],
              adj15:[this.barValues.adj15<3.8? this.ci.x.adj15 : 50],
              adj20: [this.barValues.adj20<3.8? this.ci.x.adj20 : 50],
            };
            
            break;
          case "diab":
            this.textOffset.curr= [this.barValues.current<=12?7:(-107)];
            this.textOffset.adj5= [this.barValues.adj5<=12?7:(-107)];
            this.textOffset.adj10= [this.barValues.adj10<=12?7:(-107)];
            this.textOffset.adj15= [0];
            this.textOffset.adj20= [0];
            this.white = {
              current:[this.barValues.current<=12?false:true],
              adj5:[this.barValues.adj5<=12?false:true],
              adj10:[this.barValues.adj10<=12?false:true],
              adj15:[false],
              adj20: [false],
            };
            break;
          case "nafld":
            this.textOffset.curr= [11];
            this.textOffset.adj5= [11];
            this.textOffset.adj10= [11];
            this.textOffset.adj15= [11];
            this.textOffset.adj20= [11];
            
            break;
          case "pcos":
            this.textOffset.curr= [7];
            this.textOffset.adj5= [7];
            this.textOffset.adj10= [-218];
            this.white.adj10=[true];
            break;
          case "hyplip":
            this.textOffset.curr= [this.barValues.current[0]<270?7:-42, this.barValues.current[1]<270?7:-42];
            this.textOffset.adj5= [this.barValues.adj5[0]<270?7:-42, this.barValues.adj5[1]<270?7:-42];
            this.textOffset.adj10= [this.barValues.adj10[0]<270?7:-42,  this.barValues.adj10[1]<270?7:-42];
            this.textOffset.adj15= [this.barValues.adj15[0]<270?7:-42,  this.barValues.adj15[1]<270?7:-42];
            this.textOffset.adj20= [this.barValues.adj20[0]<270?7:-42, this.barValues.adj20[1]<270?7:-42];
            this.white = {
              current: [this.barValues.current[0]<270?false:true, this.barValues.current[1]<270?false:true],
              adj5: [this.barValues.adj5[0]<270?false:true, this.barValues.adj5[1]<270?false:true],
              adj10: [this.barValues.adj10[0]<270?false:true, this.barValues.adj10[1]<270?false:true],
              adj15: [this.barValues.adj15[0]<270?false:true, this.barValues.adj15[1]<270?false:true ],
              adj20: [this.barValues.adj20[0]<270?false:true, this.barValues.adj20[1]<270?false:true ],
            };
            break;
          case "hypten":
            // console.log("hypten - text: "+JSON.stringify(this.barValues));
            this.textOffset.curr= [this.barValues.current[0]<170?7:-57, this.barValues.current[1]<170?7:-57];
            this.textOffset.adj5= [this.barValues.adj5[0]<170?7:-57, this.barValues.adj5[1]<170?7:-57];
            this.textOffset.adj10= [this.barValues.adj10[0]<170?7:-57, this.barValues.adj10[1]<170?7:-57];
            this.textOffset.adj15= [0, 0];
            this.textOffset.adj20= [0, 0];
            // console.log("hypten - white: ");
            this.white = {
              current: [this.barValues.current[0]<170?false:true, this.barValues.current[1]<170?false:true],
              adj5: [this.barValues.adj5[0]<170?false:true, this.barValues.adj5[1]<170?false:true],
              adj10: [this.barValues.adj10[0]<170?false:true, this.barValues.adj10[1]<170?false:true],
              adj15: [false, false],
              adj20: [false, false]
            };
            // console.log("hypten - white: "+JSON.stringify(this.white));
            break;
          default:
            this.textOffset.curr= [7];
            this.textOffset.adj5= [7];
            this.textOffset.adj10= [7];
            this.textOffset.adj15= [7];
            this.textOffset.adj20= [7];
        }
        // place bars
        switch (this.disease) {
            case "hyplip":
              barHeight=23;
              yPos={
                current:[1+2*((this.graphHeight-132)/3), 1+this.graphHeight-((this.graphHeight-138)/3)-46],
                adj:[1+2*((this.graphHeight-132)/3)+barHeight, 1+this.graphHeight-((this.graphHeight-138)/3)-23],
              };
              barWidth={
                current:[this.getBarWidth(this.barValues.current[0]), this.getBarWidth(this.barValues.current[1])],
                adj5:[this.getBarWidth(this.barValues.adj5[0]), this.getBarWidth(this.barValues.adj5[1])],
                adj10:[this.getBarWidth(this.barValues.adj10[0]), this.getBarWidth(this.barValues.adj10[1])],
                adj15:[this.getBarWidth(this.barValues.adj15[0]), this.getBarWidth(this.barValues.adj15[1]) ],
                adj20:[this.getBarWidth(this.barValues.adj20[0]), this.getBarWidth(this.barValues.adj20[1]) ]
              };
              break;
            case "hypten":
              barHeight=32.4;
              yPos={
                current:[1+((this.graphHeight-129.6)/3), 1+((this.graphHeight-129.6)*2/3)+(2*barHeight)],
                adj:[1+((this.graphHeight-129.6)/3)+barHeight, 1+((this.graphHeight-129.6)*2/3)+(3*barHeight)],
              };
              barWidth={
                current:[this.getBarWidth(this.barValues.current[0]), this.getBarWidth(this.barValues.current[1])],
                adj5:[this.getBarWidth(this.barValues.adj5[0]), this.getBarWidth(this.barValues.adj5[1])],
                adj10:[this.getBarWidth(this.barValues.adj10[0]), this.getBarWidth(this.barValues.adj10[1])],
                adj15:[0],
                adj20:[0]
              };
              break;
            case "diab":
              barHeight=63;
              yPos={
                current:[1+((this.graphHeight/2)-barHeight)],
                adj:[1+(this.graphHeight/2)],
              };
              barWidth={
                current:[this.getBarWidth(this.barValues.current[0])],
                adj5:[this.getBarWidth(this.barValues.adj5[0])],
                adj10:[this.getBarWidth(this.barValues.adj10[0])],
                adj15:[0],
                adj20:[0]
              };
              break;
            
            default:
              barHeight=63;
              yPos={
                current:[1+((this.graphHeight-(2*barHeight))/3)],
                adj:[1+(2*((this.graphHeight-(2*barHeight))/3))+barHeight],
              };
              barWidth={
                current:[this.getBarWidth(this.barValues.current[0])],
                adj5:[this.getBarWidth(this.barValues.adj5[0])],
                adj10:[(this.barValues.adj10!==undefined)?this.getBarWidth(this.barValues.adj10[0]):0],
                adj15:[(this.barValues.adj15!==undefined)?this.getBarWidth(this.barValues.adj15[0]):0],
                adj20:[(this.barValues.adj20!==undefined)?this.getBarWidth(this.barValues.adj20[0]):0]
              };
              break;
          }
          if (barCount<1) {
            this.currentBars.push({
              x:this.xOffset,
              y:0,
              width:0,
              height:0,
            });
          } else {
          for(var i=0; i<barCount; i++) {
              if (this.barValues.current[0]!==undefined) {
                this.currentBars.push({
                  x:this.xOffset,
                  y:yPos.current[i],
                  width:barWidth.current[i],
                  height:barHeight,
                });
                
                this.currentText.push({
                  x:this.barValues.current[i]<this.lblStartX? this.xOffset+this.textOffset.curr[i]: this.xOffset+barWidth.current[i]+this.textOffset.curr[i],
                  y:yPos.current[i]+(barHeight/2)+1,
                });
                
                this.adj5Bars.push({
                  x:this.xOffset,
                  y:yPos.adj[i],
                  width:barWidth.adj5[i],
                  height:barHeight,
                });
                
                this.adj5Text.push({
                  x:this.barValues.adj5[i]<this.lblStartX? this.xOffset+this.textOffset.adj5[i]: this.xOffset+barWidth.adj5[i]+this.textOffset.adj5[i],
                  y:yPos.adj[i]+(barHeight/2)+1,
                });
                this.adj10Bars.push({
                  x:this.xOffset,
                  y:yPos.adj[i],
                  width:barWidth.adj10[i],
                  height:barHeight,
                });
                
                if (this.barValues.adj10!==undefined && barWidth.adj10!==undefined) {
                this.adj10Text.push({
                  x:this.barValues.adj10[i]<this.lblStartX? this.xOffset+this.textOffset.adj10[i]: this.xOffset+barWidth.adj10[i]+this.textOffset.adj10[i],
                  y:yPos.adj[i]+(barHeight/2)+1,
                });
                }
                this.adj15Bars.push({
                  x:this.xOffset,
                  y:yPos.adj[i],
                  width:barWidth.adj15[i],
                  height:barHeight,
                });
                if (this.barValues.adj15!==undefined && barWidth.adj15!==undefined) {
                this.adj15Text.push({
                  x:this.barValues.adj15[i]<this.lblStartX? this.xOffset+this.textOffset.adj15[i]: this.xOffset+barWidth.adj15[i]+this.textOffset.adj15[i],
                  y:yPos.adj[i]+(barHeight/2)+1,
                });
                }
                this.adj20Bars.push({
                  x:this.xOffset,
                  y:yPos.adj[i],
                  width:barWidth.adj20[i],
                  height:barHeight,
                });
                if (this.barValues.adj20!==undefined && barWidth.adj20!==undefined) {
                this.adj20Text.push({
                  x:this.barValues.adj20[i]<this.lblStartX? this.xOffset+this.textOffset.adj20[i]: this.xOffset+barWidth.adj20[i]+this.textOffset.adj20[i],
                  y:yPos.adj[i]+(barHeight/2)+1,
                });
                }
              }
          }
        }
        
      },
      
    },
    
    watch: {
      barValues: function(oldVal, newVal) {
        if(oldVal !== newVal) {
          this.currentBars= [];
          this.adj5Bars= [];
          this.adj10Bars= [];
          this.adj15Bars= [];
          this.adj20Bars= [];
          this.currentText= [];
          this.adj5Text= [];
          this.adj10Text= [];
          this.adj15Text= [];
          this.adj20Text= [];
          this.drawBars();
        }
      },
      
      displayGraph: function(oldVal, newVal) {
        if(oldVal !== newVal && this.isSummary) {
          this.xOffset= 40;
          this.graphWidth= 473;
          this.graphHeight= 186;
          this.currentBars= [];
          this.adj5Bars= [];
          this.adj10Bars= [];
          this.adj15Bars= [];
          this.adj20Bars= [];
          this.currentText= [];
          this.adj5Text= [];
          this.adj10Text= [];
          this.adj15Text= [];
          this.adj20Text= [];
          this.textOffset= {
            curr: [0],
            adj5: [0],
            adj10: [0],
            adj15: [0],
            adj20: [0],
          },
          this.xlabelpos= [];
          this.ylabelpos= [];
          this.ylabelBmi= [
                  {x: 26, y: 1, value:''},
                  {x: 26, y: 1, value:''},
                  {x: 26, y: 1, value:''},
                  {x: 26, y: 1, value:''},
                  {x: 26, y: 1, value:''}
                  ];
          this.lblYMarginX= 28;
          this.labelY= {
            count: 0,
            height: 0,
          };
          this.labelX= {
            count: 0,
            width: 0,
          };
          this.white= {
            current:[false],
          adj5:[false],
          adj10: [false],
          adj15:[false],
          adj20: [false],
          };
          
          // set graph width
          switch (this.disease) {
            case "hyplip":
            case "hypten":
              this.graphWidth=511;
              this.xOffset=25;
              break;
            case "diab":
              this.graphWidth=528;
              this.xOffset=1;
              break;
            default:
              this.graphWidth=473;
              this.xOffset=40;
          }
      
          // create labels
          this.createLabelsY();
          this.createLabelsX();
          this.drawBars();
        }
      },
    },
  };
</script>


<style lang="scss" thisd>

</style>
